import { Reducer } from 'react';
import { Action } from 'redux';
import Actions from '../actions';
import { AiScriberState } from './state';
import {
    AiScriberStatusChangedAction,
    AiScriberSessionStartedAction,
    AiScriberTranscriptDeltaReceivedAction,
    AiScriberReportDraftReceivedAction,
} from './types';

const initialState: AiScriberState = {
    status: 'idle',
    elapsedSeconds: 0,
    transcript: '',
};

export const reconsilor = (_: AiScriberState): AiScriberState => ({ ...initialState });

export const reducer: Reducer<AiScriberState | undefined, Action<Actions>> = (
    state = initialState,
    action,
): AiScriberState => {
    switch (action.type) {
        case Actions.LoggedOut:
        case Actions.LoggedIn:
        case Actions.AiScriberReset:
            return initialState;

        case Actions.AiScriberStatusChanged: {
            const a = action as AiScriberStatusChangedAction;
            return {
                ...state,
                status: a.payload.status,
                ...(a.payload.appointmentId !== undefined && { appointmentId: a.payload.appointmentId }),
                ...(a.payload.selectedTemplateId !== undefined && { selectedTemplateId: a.payload.selectedTemplateId }),
                ...(a.payload.errorKey !== undefined && { errorKey: a.payload.errorKey }),
                // reset elapsed and transcript when starting a new session
                ...(a.payload.status === 'requestingMicrophonePermission' && { elapsedSeconds: 0, transcript: '', sessionId: undefined }),
            };
        }

        case Actions.AiScriberSessionStarted: {
            const a = action as AiScriberSessionStartedAction;
            return { ...state, sessionId: a.payload.sessionId };
        }

        case Actions.AiScriberTranscriptDeltaReceived: {
            const a = action as AiScriberTranscriptDeltaReceivedAction;
            return { ...state, transcript: state.transcript + a.payload.delta };
        }

        case Actions.AiScriberElapsedTick:
            return { ...state, elapsedSeconds: state.elapsedSeconds + 1 };

        case Actions.AiScriberReportDraftReceived: {
            const a = action as AiScriberReportDraftReceivedAction;
            return {
                ...state,
                status: 'draftReady',
                reportDraft: a.payload.reportDraft ?? undefined,
                ...(a.payload.reportDraft !== null && { selectedTemplateId: a.payload.templateId }),
            };
        }

        default:
            return state;
    }
};
